// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CEEvP{padding:0 24px}.ZfLNL{position:absolute;bottom:24px;left:16px;right:16px}.u4CQa{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `CEEvP`,
	"ctaWrapper": `ZfLNL`,
	"ctaButton": `u4CQa`
};
export default ___CSS_LOADER_EXPORT___;
